import { render, staticRenderFns } from "./contest-problem.vue?vue&type=template&id=ab7fd752&scoped=true"
import script from "./contest-problem.vue?vue&type=script&lang=js"
export * from "./contest-problem.vue?vue&type=script&lang=js"
import style0 from "./contest-problem.vue?vue&type=style&index=0&id=ab7fd752&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7fd752",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab7fd752')) {
      api.createRecord('ab7fd752', component.options)
    } else {
      api.reload('ab7fd752', component.options)
    }
    module.hot.accept("./contest-problem.vue?vue&type=template&id=ab7fd752&scoped=true", function () {
      api.rerender('ab7fd752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/detail-pane/contest-problem.vue"
export default component.exports